var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "12.124", viewBox: "0 0 15 12.124" }, props),
    React.createElement("path", { className: styles["cnsi-a"] || "cnsi-a", d: "M1.2 3.297h12.601v1.7H1.2zM0 0h4.099v1.7H0zM10.901 0H15v1.7h-4.099zM8.856 10.424h3.187v1.7H8.856zM2.957 10.424h3.187v1.7H2.957z" }),
    React.createElement("path", { className: styles["cnsi-a"] || "cnsi-a", d: "M1.2 1.7h1.7v3.194H1.2zM3.701 7.619h1.7v2.805h-1.7zM12.1 1.7h1.7v3.194h-1.7zM9.599 7.619h1.7v2.805h-1.7z" }),
    React.createElement("path", { className: styles["cnsi-a"] || "cnsi-a", d: "M3.701 4.147H11.3v5.172H3.701z" })
  );
});